const LogoIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='84'
      height='23.914'
      viewBox='0 0 84 23.914'
    >
      <g
        id='Group_131'
        data-name='Group 131'
        transform='translate(12413.82 -2323.969)'
      >
        <path
          id='Path_192'
          data-name='Path 192'
          d='M425.289,401.927V397.5h-1.234v4.5c0,1.009-.374,1.309-1,1.309a2.527,2.527,0,0,1-.757-.112l-.1.982a3.36,3.36,0,0,0,.786.093,2.037,2.037,0,0,0,2.309-2.337'
          transform='translate(-12808.656 1933.428)'
          fill='#13714d'
        />
        <path
          id='Path_193'
          data-name='Path 193'
          d='M453.8,394.058a.636.636,0,1,0-.617-.635.626.626,0,0,0,.617.635'
          transform='translate(-12826.604 1936.155)'
          fill='#13714d'
        />
        <path
          id='Path_194'
          data-name='Path 194'
          d='M455.684,391.032a.589.589,0,1,0-.57-.589.579.579,0,0,0,.57.589'
          transform='translate(-12827.724 1937.854)'
          fill='#13714d'
        />
        <path
          id='Path_195'
          data-name='Path 195'
          d='M456.846,393.422a.622.622,0,1,0,.626-.636.623.623,0,0,0-.626.636'
          transform='translate(-12828.727 1936.156)'
          fill='#13714d'
        />
        <path
          id='Path_196'
          data-name='Path 196'
          d='M461.682,394.058a.636.636,0,1,0-.617-.635.621.621,0,0,0,.617.635'
          transform='translate(-12831.171 1936.155)'
          fill='#13714d'
        />
        <path
          id='Path_197'
          data-name='Path 197'
          d='M465.37,394.058a.636.636,0,1,0-.617-.635.627.627,0,0,0,.617.635'
          transform='translate(-12833.307 1936.155)'
          fill='#13714d'
        />
        <path
          id='Path_198'
          data-name='Path 198'
          d='M455.344,396.688a11.52,11.52,0,0,0-.3-2.589l-1.206.168a11.6,11.6,0,0,1,.271,2.505c0,.29-.028.748-.066,1.122h-.327c-.823,0-1.028-.262-1.028-1.038v-2.2h-1.178v2.234c0,.673-.15,1.075-.692,1.075s-.711-.383-.711-1.084v-1.851h-1.234v1.692c0,.925-.234,1.169-.841,1.169h-.991v-3.422H445.81v3.422h-2.084v-3.422h-1.234v3.422h-1.953v-1.318a1.959,1.959,0,0,0-2.16-2.225A2.255,2.255,0,0,0,436,396.772c0,.85-.252,1.122-.7,1.122h-.981v-5.618H433.08v6.591h2.169a1.274,1.274,0,0,0,1.233-.72c.28.458.823.72,1.926.72h9.617c.692,0,1.075-.243,1.243-.692a1.271,1.271,0,0,0,1.328.776,1.4,1.4,0,0,0,1.355-.776c.206.5.7.692,1.514.692H455.2a18.664,18.664,0,0,0,.14-2.178m-16.011,1.206h-.8c-.963,0-1.318-.412-1.318-1.234,0-.794.4-1.337,1.084-1.337s1.038.411,1.038,1.393Z'
          transform='translate(-12814.961 1936.451)'
          fill='#13714d'
        />
        <path
          id='Path_199'
          data-name='Path 199'
          d='M493.242,392.276h-1.234v5.618h-2.888v.972h4.123Z'
          transform='translate(-12847.419 1936.451)'
          fill='#13714d'
        />
        <path
          id='Path_200'
          data-name='Path 200'
          d='M490.8,397.1l-1.365-4.983-1.225.168,1.336,4.814Z'
          transform='translate(-12846.892 1936.541)'
          fill='#13714d'
        />
        <rect
          id='Rectangle_43'
          data-name='Rectangle 43'
          width='1.234'
          height='6.591'
          transform='translate(-12352.599 2328.727)'
          fill='#13714d'
        />
        <path
          id='Path_201'
          data-name='Path 201'
          d='M518.3,401.722v-2.365a1.914,1.914,0,0,0-2.113-2.15,2.254,2.254,0,0,0-2.44,2.356c0,1.318.682,2.159,2.505,2.159Zm-3.318-2.281a1.124,1.124,0,0,1,1.113-1.262c.626,0,1,.393,1,1.327v1.243h-.711c-.973,0-1.4-.43-1.4-1.309'
          transform='translate(-12861.686 1933.595)'
          fill='#13714d'
        />
        <path
          id='Path_202'
          data-name='Path 202'
          d='M520.343,394.058a.636.636,0,1,0-.617-.635.626.626,0,0,0,.617.635'
          transform='translate(-12865.146 1936.155)'
          fill='#13714d'
        />
        <path
          id='Path_203'
          data-name='Path 203'
          d='M516.656,394.058a.636.636,0,1,0-.617-.635.621.621,0,0,0,.617.635'
          transform='translate(-12863.011 1936.155)'
          fill='#13714d'
        />
        <path
          id='Path_204'
          data-name='Path 204'
          d='M526.508,401.927V397.5h-1.235v4.5c0,1.009-.373,1.309-1,1.309a2.523,2.523,0,0,1-.757-.112l-.1.982a3.354,3.354,0,0,0,.786.093,2.037,2.037,0,0,0,2.309-2.337'
          transform='translate(-12867.282 1933.428)'
          fill='#13714d'
        />
        <rect
          id='Rectangle_44'
          data-name='Rectangle 44'
          width='1.234'
          height='6.591'
          transform='translate(-12339.289 2328.727)'
          fill='#13714d'
        />
        <path
          id='Path_205'
          data-name='Path 205'
          d='M536.429,404.171a3.358,3.358,0,0,0,.785.093,2.037,2.037,0,0,0,2.309-2.337V397.5h-1.234v4.5c0,1.009-.374,1.309-1,1.309a2.526,2.526,0,0,1-.757-.113Z'
          transform='translate(-12874.821 1933.428)'
          fill='#13714d'
        />
        <path
          id='Path_206'
          data-name='Path 206'
          d='M541.428,393.855a.645.645,0,1,0-.645-.645.646.646,0,0,0,.645.645'
          transform='translate(-12877.343 1936.284)'
          fill='#13714d'
        />
        <path
          id='Path_207'
          data-name='Path 207'
          d='M548.745,397.208a2.252,2.252,0,0,0-2.477,2.346c0,1.327.683,2.169,2.506,2.169h.729v.14c0,.879-.645,1.243-1.617,1.243a7.845,7.845,0,0,1-1.458-.159l-.075,1.01a9.827,9.827,0,0,0,1.421.122c2.094,0,2.926-1.047,2.926-2.337v-4.207a6.016,6.016,0,0,0-1.954-.327m.757,3.543h-.6c-.981,0-1.4-.458-1.4-1.309a1.124,1.124,0,0,1,1.113-1.262,2.253,2.253,0,0,1,.888.168Z'
          transform='translate(-12880.52 1933.594)'
          fill='#13714d'
        />
        <path
          id='Path_208'
          data-name='Path 208'
          d='M425.6,416.365l-.664,2a5.492,5.492,0,0,0-.218.8h-.011a6.028,6.028,0,0,0-.212-.812l-.647-1.985h-.87l-.6,3.862h.755l.218-1.78c.046-.337.086-.641.109-.984h.011a6.254,6.254,0,0,0,.246.973l.589,1.791h.738l.612-1.94a7.834,7.834,0,0,0,.212-.824h.012c.029.269.063.555.12.921l.274,1.843h.784l-.6-3.862Z'
          transform='translate(-12808.766 1922.499)'
          fill='#13714d'
        />
        <path
          id='Path_209'
          data-name='Path 209'
          d='M435.11,415.807a.443.443,0,1,0,0,.887.453.453,0,0,0,.458-.446.448.448,0,0,0-.458-.441'
          transform='translate(-12815.875 1922.822)'
          fill='#13714d'
        />
        <rect
          id='Rectangle_45'
          data-name='Rectangle 45'
          width='0.732'
          height='2.844'
          transform='translate(-12381.132 2339.882)'
          fill='#13714d'
        />
        <path
          id='Path_210'
          data-name='Path 210'
          d='M440.1,418.635a1.038,1.038,0,0,0-.967.572l-.006-.006a3.085,3.085,0,0,0,.04-.5h-.692v2.844h.732v-1.373c0-.5.292-.921.664-.921.269,0,.349.177.349.475v1.82h.727v-2c0-.5-.206-.91-.847-.91'
          transform='translate(-12818.089 1921.184)'
          fill='#13714d'
        />
        <rect
          id='Rectangle_46'
          data-name='Rectangle 46'
          width='0.732'
          height='2.844'
          transform='translate(-12376.344 2339.882)'
          fill='#13714d'
        />
        <path
          id='Path_211'
          data-name='Path 211'
          d='M446.488,415.807a.443.443,0,1,0,0,.887.453.453,0,0,0,.458-.446.448.448,0,0,0-.458-.441'
          transform='translate(-12822.466 1922.822)'
          fill='#13714d'
        />
        <path
          id='Path_212'
          data-name='Path 212'
          d='M450.231,419.482c0-.177.137-.292.423-.292a2,2,0,0,1,.526.074l.023-.578a3.273,3.273,0,0,0-.521-.051c-.8,0-1.207.412-1.207.91,0,.967,1.15.681,1.15,1.184,0,.189-.183.3-.463.3a2.521,2.521,0,0,1-.612-.086l-.017.6a3.9,3.9,0,0,0,.6.051c.778,0,1.27-.377,1.27-.938,0-.921-1.166-.715-1.166-1.179'
          transform='translate(-12824.458 1921.184)'
          fill='#13714d'
        />
        <path
          id='Path_213'
          data-name='Path 213'
          d='M455.888,416.243l-.732.194v.875h-.486v.566h.492v1.442c0,.664.194.893.824.893a2.527,2.527,0,0,0,.6-.074v-.59a1.4,1.4,0,0,1-.355.046c-.252,0-.337-.1-.337-.469v-1.248h.692v-.566h-.692Z'
          transform='translate(-12827.466 1922.569)'
          fill='#13714d'
        />
        <path
          id='Path_214'
          data-name='Path 214'
          d='M461.275,419.265h-.011a3.739,3.739,0,0,0,.051-.572h-.692v2.844h.732v-1.161c0-.789.263-1.133.789-1.024l.034-.721a.864.864,0,0,0-.9.635'
          transform='translate(-12830.914 1921.189)'
          fill='#13714d'
        />
        <path
          id='Path_215'
          data-name='Path 215'
          d='M466.244,419.751c-.092.269-.212.647-.274.9h-.006c-.063-.257-.138-.538-.223-.784l-.383-1.087h-.813l1.047,2.844-.1.274c-.149.424-.309.532-.549.532a1.3,1.3,0,0,1-.389-.063l-.046.629a1.869,1.869,0,0,0,.4.046c.652,0,.95-.269,1.288-1.156l1.167-3.107h-.784Z'
          transform='translate(-12833.166 1921.098)'
          fill='#13714d'
        />
        <path
          id='Path_216'
          data-name='Path 216'
          d='M476.2,418.649a1.43,1.43,0,0,0-1.453,1.528c0,1.012.521,1.43,1.328,1.43a1.438,1.438,0,0,0,1.453-1.533,1.239,1.239,0,0,0-1.328-1.424m-.063,2.334c-.424,0-.635-.3-.635-.881s.321-.835.646-.835c.429,0,.624.3.624.847,0,.578-.274.87-.635.87'
          transform='translate(-12839.094 1921.176)'
          fill='#13714d'
        />
        <path
          id='Path_217'
          data-name='Path 217'
          d='M482.422,416.659v.229h-.5v.566h.5v2.277h.727v-2.277h.664v-.566h-.664v-.24c0-.377.143-.543.463-.543a1.11,1.11,0,0,1,.355.051l.052-.6a2.083,2.083,0,0,0-.464-.045c-.778,0-1.133.377-1.133,1.15'
          transform='translate(-12843.252 1922.994)'
          fill='#13714d'
        />
        <rect
          id='Rectangle_47'
          data-name='Rectangle 47'
          width='0.744'
          height='3.862'
          transform='translate(-12357.701 2338.863)'
          fill='#13714d'
        />
        <path
          id='Path_218'
          data-name='Path 218'
          d='M495.824,418.635a1.038,1.038,0,0,0-.967.572l-.005-.006a3.132,3.132,0,0,0,.04-.5H494.2v2.844h.732v-1.373c0-.5.292-.921.664-.921.269,0,.349.177.349.475v1.82h.727v-2c0-.5-.206-.91-.847-.91'
          transform='translate(-12850.361 1921.184)'
          fill='#13714d'
        />
        <path
          id='Path_219'
          data-name='Path 219'
          d='M502.688,420.089a5.952,5.952,0,0,0-.172.606H502.5c-.051-.206-.12-.435-.189-.629l-.452-1.282h-.8l1.053,2.844h.744l1.064-2.844h-.778Z'
          transform='translate(-12854.337 1921.097)'
          fill='#13714d'
        />
        <path
          id='Path_220'
          data-name='Path 220'
          d='M509.7,418.635a1.341,1.341,0,0,0-1.333,1.51,1.265,1.265,0,0,0,1.408,1.453,2.82,2.82,0,0,0,1.018-.183l-.069-.566a2.038,2.038,0,0,1-.83.177.689.689,0,0,1-.784-.789h1.762a2.419,2.419,0,0,0,.023-.332,1.137,1.137,0,0,0-1.2-1.27m-.578,1.1a.569.569,0,0,1,.555-.566.483.483,0,0,1,.492.566Z'
          transform='translate(-12858.565 1921.184)'
          fill='#13714d'
        />
        <path
          id='Path_221'
          data-name='Path 221'
          d='M516.2,419.482c0-.177.137-.292.423-.292a2,2,0,0,1,.526.074l.023-.578a3.278,3.278,0,0,0-.521-.051c-.8,0-1.207.412-1.207.91,0,.967,1.15.681,1.15,1.184,0,.189-.183.3-.463.3a2.525,2.525,0,0,1-.612-.086l-.017.6a3.906,3.906,0,0,0,.6.051c.778,0,1.27-.377,1.27-.938,0-.921-1.167-.715-1.167-1.179'
          transform='translate(-12862.667 1921.184)'
          fill='#13714d'
        />
        <path
          id='Path_222'
          data-name='Path 222'
          d='M521.857,416.243l-.732.194v.875h-.486v.566h.492v1.442c0,.664.194.893.823.893a2.531,2.531,0,0,0,.6-.074v-.59a1.406,1.406,0,0,1-.355.046c-.252,0-.337-.1-.337-.469v-1.248h.693v-.566h-.693Z'
          transform='translate(-12865.675 1922.569)'
          fill='#13714d'
        />
        <path
          id='Path_223'
          data-name='Path 223'
          d='M529.906,418.635a1.008,1.008,0,0,0-.927.572.735.735,0,0,0-.784-.572,1.019,1.019,0,0,0-.938.572h-.011a3.361,3.361,0,0,0,.04-.51h-.692v2.844h.732V420.18c0-.532.315-.932.652-.932.28,0,.338.212.338.492v1.8h.721V420.18c0-.555.332-.932.652-.932.269,0,.338.189.338.492v1.8h.732v-1.957c0-.646-.3-.95-.852-.95'
          transform='translate(-12869.124 1921.184)'
          fill='#13714d'
        />
        <path
          id='Path_224'
          data-name='Path 224'
          d='M539.222,418.635a1.341,1.341,0,0,0-1.333,1.51A1.265,1.265,0,0,0,539.3,421.6a2.821,2.821,0,0,0,1.018-.183l-.069-.566a2.035,2.035,0,0,1-.83.177.689.689,0,0,1-.784-.789h1.762a2.358,2.358,0,0,0,.023-.332,1.137,1.137,0,0,0-1.2-1.27m-.578,1.1a.569.569,0,0,1,.555-.566.483.483,0,0,1,.492.566Z'
          transform='translate(-12875.667 1921.184)'
          fill='#13714d'
        />
        <path
          id='Path_225'
          data-name='Path 225'
          d='M546.977,418.635a1.039,1.039,0,0,0-.967.572L546,419.2a3.131,3.131,0,0,0,.04-.5h-.692v2.844h.732v-1.373c0-.5.292-.921.664-.921.269,0,.349.177.349.475v1.82h.727v-2c0-.5-.206-.91-.847-.91'
          transform='translate(-12879.989 1921.184)'
          fill='#13714d'
        />
        <path
          id='Path_227'
          data-name='Path 227'
          d='M370.261,392.851a2.313,2.313,0,0,0-1.608,2.5,2.925,2.925,0,0,1,1.811-1.729,3.389,3.389,0,0,0-.908,2.917c.042-.207.4-1.86,1.66-2.208a3.158,3.158,0,0,0-.386,2.64,4.039,4.039,0,0,1,.834-1.809,5.328,5.328,0,0,1,.276,1.938H371.7l.231,1.507h-.187l.179,1.506h-.155l.2,1.928-.677.368v.09h1.9v-.09l-.678-.368.2-1.928h-.156l.179-1.506h-.187l.231-1.507h-.236a5.315,5.315,0,0,1,.275-1.938,4.039,4.039,0,0,1,.834,1.809,3.154,3.154,0,0,0-.387-2.64c1.257.348,1.618,2,1.66,2.208a3.389,3.389,0,0,0-.908-2.917,2.921,2.921,0,0,1,1.811,1.729,2.313,2.313,0,0,0-1.607-2.5,2.381,2.381,0,0,1,.258-.024,4.035,4.035,0,0,1,1.477.381,2.069,2.069,0,0,0-2.063-1.076c-.066,0-.118,0-.118,0s.056-.409.8-.409a2.6,2.6,0,0,1,.451.04,1.7,1.7,0,0,0-1.073-.4,1.851,1.851,0,0,0-1.311.68c-.324-.237.073-.627.238-.734a.323.323,0,0,0-.161-.039.4.4,0,0,0-.269.118.447.447,0,0,1,.249-.446.542.542,0,0,1-.921,0,.447.447,0,0,1,.249.446.4.4,0,0,0-.27-.118.323.323,0,0,0-.16.039c.166.108.563.5.238.734a1.851,1.851,0,0,0-1.312-.68,1.706,1.706,0,0,0-1.073.4,2.612,2.612,0,0,1,.452-.04c.746,0,.8.409.8.409s-.053,0-.118,0a2.071,2.071,0,0,0-2.063,1.076,4.037,4.037,0,0,1,1.477-.381,2.38,2.38,0,0,1,.26.024m7.551,8.409c-2.176,0-5.567,2.235-5.567,2.235l-.006,0-.005,0s-3.391-2.235-5.567-2.235a2.877,2.877,0,0,0-1.953.574,3.189,3.189,0,0,1,1.132-.164,6.787,6.787,0,0,1,2.6.645c1.717.819,3.064,1.63,3.064,1.63l.017.01-1.68,1.065s-.57-.683-1.073-.683c-.325,0-.384.191-.384.276a.254.254,0,0,0,.266.261c.213,0,.223-.148.223-.2.028.012.049.007.077.047s.359.562.359.562-1.066.591-1.142.591c-.056,0-.16-.13-.263-.13a.1.1,0,0,0-.1.109.8.8,0,0,0,.631.5,1.169,1.169,0,0,0,.35-.028,9.969,9.969,0,0,0,.965-.437s.367.459.625.459l.128,0a1.526,1.526,0,0,0,.273-.031.772.772,0,0,0,.343.139.285.285,0,0,0,.313-.258.266.266,0,0,0-.271-.285.232.232,0,0,0-.232.191c-.04,0-.068,0-.068,0l-.52-.548,1.9-1.168,1.9,1.168-.52.548s-.028,0-.068,0a.232.232,0,0,0-.233-.191.266.266,0,0,0-.27.285.284.284,0,0,0,.313.258.772.772,0,0,0,.343-.139,1.526,1.526,0,0,0,.273.031l.128,0c.258,0,.625-.459.625-.459a10,10,0,0,0,.965.437,1.172,1.172,0,0,0,.351.028.8.8,0,0,0,.63-.5.1.1,0,0,0-.1-.109c-.1,0-.208.13-.263.13-.075,0-1.142-.591-1.142-.591s.329-.522.358-.562.05-.035.078-.047c0,.049.01.2.223.2a.254.254,0,0,0,.266-.261c0-.085-.059-.276-.383-.276-.5,0-1.073.683-1.073.683l-1.68-1.065.017-.01s1.347-.811,3.063-1.63a6.793,6.793,0,0,1,2.6-.645,3.191,3.191,0,0,1,1.132.164,2.879,2.879,0,0,0-1.953-.574'
          transform='translate(-12775.364 1937.221)'
          fill='#13714d'
        />
        <path
          id='Path_228'
          data-name='Path 228'
          d='M378.572,404.883H357.18V380.969h21.392Zm-20.178-1.214h18.964V382.183H358.394Z'
          transform='translate(-12771 1943)'
          fill='#13714d'
        />
      </g>
    </svg>
  );
};
export default LogoIcon;
